import { DOCUMENT } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit,
} from "@angular/core";
import { MatSnackBar, MatSnackBarDismiss } from "@angular/material";
import { Event, NavigationEnd, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { ErrorMessage } from "app/core/error-handler/constants";
import { ErrorHandlerService } from "app/core/error-handler/services/error-handler.service";
import { ErrorStateInterface } from "app/core/error-handler/state/models";

@Component({
  selector: "cz-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  constructor(
    private _router: Router,
    @Inject(DOCUMENT) private _document: HTMLDocument,
    private readonly _snackBar: MatSnackBar,
    private readonly _errorHandlerService: ErrorHandlerService,
    private readonly _translateService: TranslateService,
  ) {}

  public ngOnInit(): void {
    // scroll to top on route change
    this._router.events.subscribe((evt: Event) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }

      const topOfPage: HTMLElement =
        this._document.querySelector(".page-view-content");
      if (topOfPage) {
        topOfPage.scrollIntoView();
      }
    });

    // initialize the global error handling
    this._errorHandlerService
      .loadError()
      .subscribe((error: ErrorStateInterface) => {
        if (error && error.ids.length > 0 && error.entities[error.ids[0]]) {
          // really making sure the error is there
          const errorMessage: string =
            error.entities[error.ids[0]].entity.message;
          const errorType: number =
            error.entities[error.ids[0]].entity.errorResponse.status;

          if (errorMessage === ErrorMessage.noSnackbar) {
            this._errorHandlerService.removeError();
            return;
          }

          if (errorType === 401) {
            // this._snackBar.open(this._translateService.instant('$lng_log_err3'), 'X', {
            //   panelClass: ['error-snackbar'],
            // });
            return;
          }

          this._snackBar.open(
            this._translateService.instant(errorMessage),
            "X",
            {
              panelClass: ["error-snackbar"],
            },
          );

          // when the user closes the snackbar
          this._snackBar._openedSnackBarRef
            .afterDismissed()
            .subscribe((info: MatSnackBarDismiss) => {
              if (info.dismissedByAction === true) {
                // clear error state
                this._errorHandlerService.removeError();
              }
            });
        }
      });
  }
}
